module.exports = __webpack_public_path__ + "img/9.7f454ce7.jpg";